<script lang="ts">
  import Popover from "@shared/svelte/Components/Popover/SimplePopover.svelte";
  import { DistributorStore } from "@distributor/svelte/Stores/DistributorStore";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  let start_date: string;
  let end_date: string;

  let showPopover: boolean = false;

  const openPopover = () => {
    showPopover = true;
  };

  const downloadSettlements = () => {
    return HttpPromise({
      method: "GET",
      url: "api/distributor/payments/settlements",
      data: {
        start_date,
        end_date,
        distributor_id: $DistributorStore.currentDistributor.distributor_id,
      },
    }).then(res => {
      if (!start_date) start_date = "up_to";
      if (!end_date) end_date = new Date().toISOString().split("T")[0];

      const filename = `settlements_${start_date}_${end_date}.csv`;
      presentForDownload(res.csv, filename);
    });
  };

  const presentForDownload = (data, filename) => {
    const a = window.document.createElement("a");
    a.href = encodeURI("data:text/csv;charset=utf-8," + data);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const downloadReport = () => {
    downloadSettlements();
    showPopover = false;
  };
</script>

<div class="fizz-flex-row-responsive">
  <button class="fizz-button-select" on:click={openPopover}>
    <span>Settlement Report</span>
  </button>
  <div class="position-relative">
    <Popover bind:show={showPopover} popoverClass={"payment_settlements"}>
      <div class="fizz-styles" style="padding: 16px;">
        <p class="fizz-stack-16"> Select a settlement start and end date to generate report.</p>
        <div class="fizz-flex-row-responsive fizz-stack-16">
          <div>
            <label class="fizz-label fizz-stack-4" for="input-text">Starting</label>
            <input type="date" bind:value={start_date} name="start_date" class="fizz-input-date" />
          </div>
          <div>
            <label class="fizz-label fizz-stack-4" for="input-text">Ending</label>
            <input type="date" bind:value={end_date} name="end_date" class="fizz-input-date" />
          </div>
        </div>
        <button
          class="fizz-button-secondary fizz-button-small float-right fizz-stack-24"
          on:click={downloadReport}
          disabled={!start_date && !end_date}>Download CSV</button
        >
      </div>
    </Popover>
  </div>
</div>
